import {CanDeactivateComponent} from './can-deactivate-component.class';
import {DynamicForm} from 'dynamic-forms-lib';

export abstract class FormComponent extends CanDeactivateComponent {

  abstract get form(): DynamicForm;

  canDeactivate(): boolean {
    // Impider que navegue fuera del componente si el form es editable y ha sido editado.
    return !(this.form.isTouched() && this.form.editable);
  }
}
